import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import AppLoader from "../../../../commons/components/Loader";
import { AppBox, AppTitle } from "../../../../commons/components";
import { useNavigate } from "react-router";
import { useSnackbar } from "../../../../redux/snackbarProvider";
import { setMicrosoftUser, setToken, setUser } from "../../../../redux/slices/session-slice";
import { appSession } from "../../../../commons";
import { User } from "../../../../commons/models/user";
import { useAppDispatch } from "../../../../hooks/app";
import { AxiosError } from "axios";
import { IServerErrorResponse } from "../../../../commons/components/interface";
import {authUserProfile} from "../../../../redux/slices/profile-slice";

const MicrosoftCallback = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const addSnackbar = useSnackbar();

  useEffect(() => {
    const handleAuth = async () => {
      await instance.initialize();
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          dispatch(setMicrosoftUser(JSON.stringify(response.account)));
          dispatch(setToken(response.accessToken));
          dispatch(authUserProfile())
            .unwrap()
            .then((user) => {
              if (user) {
                dispatch(setUser(new User().create(user) as User));
                addSnackbar({
                  key: "micorsoft-login-success",
                  text: "Login successfully",
                  variant: "success",
                });
                window.location.pathname = "manage";
              }
            })
            .catch((error: AxiosError<IServerErrorResponse>) => {
              appSession.clearSession();
              if (error.response?.status === 404) {
                addSnackbar({
                  key: "no-user",
                  text: "User not found",
                  variant: "danger",
                });
              } else {
                addSnackbar({
                  key: "micorsoft-login-unsuccess",
                  text: "Microsoft login failed",
                  variant: "danger",
                });
              }
              navigate("/auth");
            });
        }
      } catch (error) {
        addSnackbar({
          key: "error",
          text: "Microsoft login failed",
          variant: "danger",
        });
        navigate("/auth");
      }
    };
    handleAuth();
  }, [instance]);

  return (
    <AppBox>
      <AppLoader size="lg" />
      <AppTitle
        as="h3"
        color="accent"
        size="lg"
        style={{
          position: "absolute",
          top: "60%",
          left: "50%",
          transform: "translate(-50%,-60%)",
        }}
      >
        Redirecting to the application....
      </AppTitle>
    </AppBox>
  );
};

export default MicrosoftCallback;
